import React from "react";
import { useTranslation } from "i18n";
import { useGetTraining } from "pages/Profile/hooks/useGetTraining";
import { sanitizeHighlightsForDisplay } from "shared/utils/dom/sanitizeHighlightsHtml";

const TrainingPrint = () => {
  const { t } = useTranslation();
  const { notes } = useGetTraining();

  if (!notes) return null;

  return (
    <div className="mt-4">
      <span className="font-bold">{t("performer:profile.training.title")}</span>
      <p
        dangerouslySetInnerHTML={{
          __html: sanitizeHighlightsForDisplay(notes),
        }}
      />
    </div>
  );
};

export default TrainingPrint;
